// T22.747: say WHY the keep-wheels popup opened when a create / clone / upload
// was refused (402 downgrade_over_limit). Before this the popup appeared over
// the Create Wheel wizard's Build step with no word that creating was blocked.
// PURE: no React, no network.

export const BLOCKED_ACTION = {
  CREATE: "create",
  CLONE: "clone",
  UPLOAD: "upload",
  OTHER: "other",
};

const HEADLINE = {
  [BLOCKED_ACTION.CREATE]: "You can't create a new wheel right now.",
  [BLOCKED_ACTION.CLONE]: "You can't clone this wheel right now.",
  [BLOCKED_ACTION.UPLOAD]: "Your upload didn't go through.",
  [BLOCKED_ACTION.OTHER]: "That action is paused.",
};

export const BLOCKED_BODY =
  "Your account is over its plan's limits, so new wheels, clones and uploads " +
  "are paused until you choose which wheels to keep below.";

/** Which user action a refused request was, from its axios config. */
export const blockedActionFromRequest = (config) => {
  const method = String(config?.method || "").toLowerCase();
  const url = String(config?.url || "").split("?")[0];
  if (/clone/i.test(url)) return BLOCKED_ACTION.CLONE;
  if (/upload|presign|media|attachment|file/i.test(url)) return BLOCKED_ACTION.UPLOAD;
  if (method === "post" && /\/wheel\/?$/.test(url)) return BLOCKED_ACTION.CREATE;
  return BLOCKED_ACTION.OTHER;
};

export const blockedHeadline = (action) =>
  HEADLINE[action] || HEADLINE[BLOCKED_ACTION.OTHER];

/** Same rule the server's gate uses (service.is_blocked_by_downgrade): an open
 *  selection while over the limit blocks, except a self-chosen downgrade picked
 *  before the paid period ends (its lower limits do not apply yet). */
export const createIsBlocked = (state) =>
  Boolean(state?.enabled && state?.must_choose && state?.reason !== "self");
